export enum targetFunctionality {
    Booking = 1,
    Equipment = 2,
    CBL = 3,
    FCR_ExportJob = 4,
    ETS = 5,
}